import { Box, Tooltip, Typography } from '@mui/material';

export default function SystemSentimentPanel({
  auditIssues
}: {
  auditIssues?: { label: string; description: string }[];
}) {
  return (
    <Box
      sx={{
        border: '1px solid #ECECEC',
        borderRadius: '8px',
        p: 2,
        mb: 2,
        background: '#fff'
      }}
    >
      <Typography mb={1} fontSize={16} fontWeight={500}>
        System Sentiment
      </Typography>

      {auditIssues?.length ? (
        <Box display='flex' flexWrap='wrap' gap={1}>
          {auditIssues.map((item) => (
            <Tooltip
              key={item.label}
              title={item.description}
              placement='top'
              arrow
              componentsProps={{
                tooltip: {
                  sx: {
                    backgroundColor: '#fff',
                    color: '#000',
                    fontSize: '12px',
                    boxShadow: '0px 2px 8px rgba(0,0,0,0.15)',
                    border: '1px solid #E5E7EB'
                  }
                },
                arrow: { sx: { color: '#fff' } }
              }}
            >
              <Box
                sx={{
                  px: 1.2,
                  py: 0.5,
                  borderRadius: 10,
                  bgcolor: '#F3F4F6',
                  fontSize: 12,
                  textWrap: 'nowrap'
                }}
              >
                {item.label}
              </Box>
            </Tooltip>
          ))}
        </Box>
      ) : (
        <Typography fontSize={12}>—</Typography>
      )}
    </Box>
  );
}
